(() => {
  const init = () => {
    document.querySelectorAll('[data-vm-quantity-status][data-product-id]').forEach((label) => {
      if (label.dataset.vmStockBound === 'true') return;
      label.dataset.vmStockBound = 'true';
      const productId = label.dataset.productId;
      const status = label.querySelector('[data-vm-stock-status]');
      if (!status || !productId || !window.MinimogEvents) return;
      window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, (variant) => {
        status.classList.toggle('is-hidden', !variant || variant.available !== true);
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
